const flow_routes = [
  {
    path: "/flows",
    name: "ListFlows",
    component: () => import("@/_flow/pages/IndexFlows.vue"),
    meta: {
      translated: "Fluxos",
      auth: true,
      permission: { act: "read", on: "User" },
    },
    children: [
      {
        path: '',
        redirect: 'list', // default child path
      },
      {
        path: "list",
        name: "ListingFlow",
        component: () => import("@/_flow/pages/ListFlows.vue"),
        meta: {
          translated: "Fluxo",
          auth: true,
          permission: { act: "read", on: "User" },
        },
        children: [
          {
            path: "create_flow",
            name: "CreateFlow",
            component: () => import("@/_flow/pages/CreateFlow.vue"),
            meta: {
              translated: "Fluxo",
              auth: true,
              permission: { act: "read", on: "User" },
            },
          },
          {
            path: "duplicate_flow/:id",
            name: "DuplicateFlow",
            component: () => import("@/_flow/pages/DuplicateFlow.vue"),
            meta: {
              translated: "Fluxo",
              auth: true,
              permission: { act: "read", on: "User" },
            },
          },
        ]
      },
      {
        path: "done_flows",
        name: "DoneFlows",
        component: () => import("@/_flow/pages/ListDoneFlows.vue"),
        meta: {
          translated: "Fluxo",
          auth: true,
          permission: { act: "read", on: "User" },
        },
      },

      {
        path: "interrupted_done_flows",
        name: "InterruptedDoneFlows",
        component: () => import("@/_flow/pages/ListInterruptedDoneFlows.vue"),
        meta: {
          translated: "Fluxo",
          auth: true,
          permission: { act: "read", on: "User" },
        },
      },
      
    ]
  },
  {
    path: "/flows/:id",
    name: "OneFlow",
    component: () => import("@/_flow/pages/OneFlow.vue"),
    meta: {
      translated: "Fluxo",
      auth: true,
      permission: { act: "read", on: "User" },
    },
  },
  {
    path: "/approve_flows/:id",
    name: "ApproveFlow",
    component: () => import("@/_flow/pages/OneFlow.vue"),
    meta: {
      translated: "Fluxo",
      auth: true,
      permission: { act: "read", on: "User" },
    },
  },
  {
    path: "/flows/:id/begin_execution",
    name: "FlowExecution",
    component: () => import("@/_flow/pages/FlowExecution.vue"),
    meta: {
      translated: "Fluxo",
      auth: true,
      permission: { act: "read", on: "User" },
    },
  },
  
  {
    path: "/done_flows/:id",
    name: "OneDoneFlow",
    component: () => import("@/_flow/pages/DoneFlow.vue"),
    meta: {
      translated: "Fluxo",
      auth: true,
      permission: { act: "read", on: "DoneFlow" },
    },
  },
];

export default flow_routes;
